import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";
import AddDistributor from "./AddDistributor";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";

const initialDistributors = [
  { name: "A U Medicals", mobile: "", gst: "37DTUP7814C1ZA", balance: "", district: "Visakhapatnam",address: "GROUND FLOOR 53-25-19, C BLOCK, VSP" },
  { name: "A L Medi Care", mobile: "", gst: "37ABAF1010J1ZT", balance: "", district: "Visakhapatnam",address: "28–6–2 YELLAMMATHOTA JN, VSP" },
  { name: "A N Z Distributors", mobile: "", gst: "37BUPJ0544J2F", balance: "", district: "Visakhapatnam",address: "FLAT NO.101, DOOR NO. 11–9–34, VSP" },
  { name: "Asia Drugs", mobile: "", gst: "37PPQ57682IAM6", balance: "", district: "Hyderabad",address: "SHOP NO 6 DOOR NO 43–9–2, HYD" },
  { name: "Anil Pharma", mobile: "", gst: "37HZCP5049B1ZY", balance: "", district: "Mumbai",address: "17–1–29 Sainath Plaza OPP KGH, VJA" },
];

const SelectDistributorModal = ({ isOpen, onClose, onSelectDistributor }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [district, setDistrict] = useState("");
  const [showDistributorModal, setShowDistributorModal] = useState(false);
  const navigate = useNavigate();
  const [distributorList, setDistributorList] = useState(initialDistributors);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0); // default to first row
  const [distributorToEdit, setDistributorToEdit] = useState(null);

  // 🔍 Filter by both district and search term
  const filteredDistributors = distributorList.filter(
  (dist) =>
    (district === "" || dist.district === district) &&
    (dist.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
     dist.gst.toLowerCase().includes(searchTerm.toLowerCase()))
);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "24px 28px",
          width: "780px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "18px",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "18px", color: "#1d1d1d" }}>
            Select a Distributor
          </h3>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              className="gradient-button"
              onClick={() => {
                setDistributorToEdit(null); // 👈 Clear edit mode
                setShowDistributorModal(true); // Show empty form
              }}
                        >
              Create New
            </button>
            <button
              onClick={onClose}
              style={{
                fontSize: "18px",
                border: "none",
                background: "none",
                cursor: "pointer",
                color: "#494949ff",
              }}
            >
              ✕
            </button>
          </div>
        </div>

        {/* SELECT + SEARCH */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <div style={{ flex: "0 0 230px" }}>
            <label
              style={{
                fontSize: "12px",
                color: "#555",
                marginBottom: "3px",
                display: "block",
              }}
            >
              DISTRICT NAME <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={district}
              onChange={(e) => setDistrict(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "13px",
                color: "#333",
              }}
            >
             <option className="custom-placeholder" value="">-- Select District --</option>
             <option value="Visakhapatnam">Visakhapatnam</option>
             <option value="Hyderabad">Hyderabad</option>
              <option value="Mumbai">Mumbai</option>
              <option value="Pune">Pune</option>
              <option value="Nagpur">Nagpur</option>
              <option value="Nashik">Nashik</option>
              <option value="Thane">Thane</option>
              <option value="Aurangabad">Aurangabad</option>
              <option value="Solapur">Solapur</option>
              <option value="Amravati">Amravati</option>
              <option value="Kolhapur">Kolhapur</option>
              <option value="Sangli">Sangli</option>
            </select>
          </div>

          <div style={{ flex: 1 }}>
  <label
    style={{
      fontSize: "12px",
      color: "#555",
      marginBottom: "3px",
      display: "block",
    }}
  >
    SEARCH DISTRIBUTOR
  </label>
  <div style={{ position: "relative" }}>
    <input
      type="text"
      placeholder="Search by Name or GSTIN"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 🔒 Stop form submission
    }
  }}
      style={{
        width: "100%",
        padding: "8px 34px 8px 10px",
        borderRadius: "6px",
        border: "1px solid #ddd",
        fontSize: "13px",
      }}
    />
    {/* Replace 🔍 with icon */}
    <FiSearch
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#232224ff",
        fontSize: "16px",
        // pointerEvents: "none", // so clicks go through to input
      }}
    />
  </div>
</div>

        </div>

        {/* TABLE */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "8px",
          }}
        >
          <thead>
            <tr>
              <th style={tableHeaderStyle}>Distributor Name/Address</th>
              <th style={tableHeaderStyle}>Mobile Number</th>
              <th style={tableHeaderStyle}>GSTIN / DRUG LIC</th>
              <th style={tableHeaderStyle}>Balance</th>
              <th style={tableHeaderStyle}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {filteredDistributors.length > 0 ? (
              filteredDistributors.map((dist, index) => (
                                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #eee",
                      borderLeft:"2px solid #148f1aff",
                      transition: "background 0.2s",
                      cursor: "pointer",
                      backgroundColor: selectedRowIndex === index ? "#e6f7e6" : "white",
                    }}
                    onMouseEnter={(e) => {
                      if (selectedRowIndex !== index) {
                        e.currentTarget.style.backgroundColor = "#f9f9f9";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedRowIndex !== index) {
                        e.currentTarget.style.backgroundColor = "white";
                      }
                    }}
                    onClick={() => {
                      setSelectedRowIndex(index); // Update selected row
                      onSelectDistributor(dist.name); // Perform existing selection logic
                    }}
                  >
                  <td style={tableCellStyle}>
                    <div style={{ fontWeight: 600, color: "#232224" }}>{dist.name}</div>
                    <div style={{ fontSize: "12px", color: "#888", marginTop: "2px" }}>
                      {dist.address || "-"}
                    </div>
                  </td>
                  <td style={tableCellStyle}>{dist.mobile || "-"}</td>
                  <td style={tableCellStyle}>
                    <div style={{ fontWeight: 600, color: "#232224" }}>{dist.gst}</div>
                    <div style={{ fontSize: "12px", color: "#888", marginTop: "2px" }}>
                      {dist.drugLic || "-"}
                    </div>
                  </td>
                  <td style={tableCellStyle}>{dist.balance || "-"}</td>
                  <td style={{ padding: "10px 8px" }}>
                    <div style={{ display: "flex", gap: "14px" }}>
                      <FiEdit2
                          size={16}
                          title="Edit"
                          style={{ color: "#076603ff", cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDistributorToEdit(dist); // <-- Set selected distributor for editing
                            setShowDistributorModal(true); // Open modal
                          }}
                        />
                      <FiTrash2
                        style={{ cursor: "pointer", color: "#585a58ff" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const confirmDelete = window.confirm(
                            `Delete ${dist.name}?`
                          );
                          if (confirmDelete) {
                            setDistributorList((prevList) =>
                              prevList.filter((_, i) => i !== index)
                            );
                          }
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={emptyTableStyle}>
                  <img
                    src="https://i.pinimg.com/736x/ef/91/d0/ef91d0fb25e0c5974a7ecbe8cf132b39.jpg"
                    alt="empty"
                    style={{ width: "200px", opacity: 0.5, marginBottom: "8px" }}
                  />
                  <div style={{ fontSize: "13px" }}>
                    We’ve Plenty Of Space For Your Data, We Promise!
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Create Distributor Modal */}
        {showDistributorModal && (
          <Modal onClose={() => setShowDistributorModal(false)}>
            <AddDistributor
  existingData={distributorToEdit} // Pass for editing
  handleSave={(newDistributor) => {
    if (distributorToEdit) {
      // EDIT mode: update
      setDistributorList((prev) =>
        prev.map((d) =>
          d.gst === distributorToEdit.gst ? newDistributor : d
        )
      );
    } else {
      // CREATE mode: add
      setDistributorList((prev) => [...prev, newDistributor]);
    }

    setDistrict(newDistributor.district);
    setShowDistributorModal(false);
    setDistributorToEdit(null); // Clear after use
  }}
  closeForm={() => {
    setShowDistributorModal(false);
    setDistributorToEdit(null);
  }}
/>

          </Modal>
        )}
      </div>
    </div>
  );
};

// Table styles
const tableHeaderStyle = {
  textAlign: "left",  
  padding: "10px 8px",
  backgroundColor: "#f8f8f8",
  fontSize: "13px",
  color: "#555",
  borderBottom: "1px solid #ddd",
};

const tableCellStyle = {
  padding: "10px 8px",
  fontSize: "13px",
  color: "#232224",
};

const emptyTableStyle = {
  textAlign: "center",
  padding: "30px 10px",
  color: "#777",
  display: "flex",
  flexDirection: "column",
  justifyContent:"center",
  alignItems: "center",
};

export default SelectDistributorModal;
